module.exports = __webpack_public_path__ + "static/media/tianyuan-1@2x.b23e5996.png";